import Immutable from 'seamless-immutable';
import IntegrationTemplateModel from './integration-template-model';

/**
 * Transforms and array of backend integration objects into a IntegrationTemplateCollection
 * @param {Object[]} integrationTemplates - backend formatted integrationTemplates
 * @returns {IntegrationTemplate[]}
 */
function deserialize(integrationTemplates = []) {
  return Immutable(_.map(integrationTemplates, IntegrationTemplateModel.deserialize));
}

/**
 * Transforms a IntegrationTemplateCollection into an array of backend integration template objects
 * @param {IntegrationTemplate[]} integrationTemplates
 * @returns {Object[]}
 */
function serialize(integrationTemplates) {
  return _.map(integrationTemplates, integrationTemplate => IntegrationTemplateModel.serialize(integrationTemplate));
}

export default {
  create: deserialize,
  deserialize,
  serialize,
};
